
  import { Component, Vue }                           from 'vue-property-decorator';
  import { Getter }                                   from 'vuex-class';
  import { EventBus,
           ConfigService,
           ConfigChatroomThemeService }               from '../..';


  @Component({
    name: 'PresentationComponent',
  })
  export default class PresentationComponent extends Vue {
    @Getter('isEmbeddedMode', { namespace: 'conversationSession' }) isEmbeddedMode!: boolean | undefined;
    @Getter('isRequestInProgress', { namespace: 'conversationSession' }) isRequestInProgress!: boolean;

    showPresentationPanel: boolean = false;

    get rootContainerStyles() {
      return ConfigChatroomThemeService.getChatroomPresentationPanelStyles(this.$vuetify);
    }

    get disclaimerPanelStyles() {
      return ConfigChatroomThemeService.getChatroomDisclaimerPanelStyles(this.$vuetify);
    }

    get presentationPanelContent() {
      return ConfigService.getPresentationPanelContent();
    }

    created() {
      let self = this;
      EventBus.$on('ON_WIDGET_LOADED_EVT', () => {
        self.showPresentationPanel = !this.isEmbeddedMode;
      });
    }

    destroy() {
      EventBus.$off('ON_WIDGET_LOADED_EVT');
    }
  }
